module.exports = __webpack_public_path__ + "img/black.31df4606.jpg";